const entityTypeToEntityIdMap = (request, context) => {
  const principalJwt = request.headers.authorization;

  let expUserId = "";
  try {
    if (principalJwt != null) {
      const baseJwt = principalJwt.replace("EGToken Principal-JWT=", "");
      const splitJwt = baseJwt.split(".");
      if (splitJwt.length > 1) {
        const decodedString = JSON.parse(atob(splitJwt[1]));
        expUserId = decodedString["sub"];
      }
    }
  } catch (error) {
    /*Not adding any logger as the server logger is throwing issues.
    And this code will be moved to some bernie plugins for tha actual implementation.*/
  }
  return {
    ExpUserID: expUserId,
  };
};

module.exports = entityTypeToEntityIdMap;
